// extracted by mini-css-extract-plugin
module.exports = {"btn-submit":"formChangePassword_btn-submit__1g2J0","field-group":"formChangePassword_field-group__1J1kq","form":"formChangePassword_form__1GSiG"};